module.exports = __webpack_public_path__ + "media/assets/images/clockwise_loader-57b8c60a46bc67e529c55cd700c91986.gif";